import { FormUtils } from '../../../utils'
import { CreditFormData } from './types'

export type CreditValidation = FormUtils.FormValidation<CreditFormData>

const creationValidator: FormUtils.DataValidatorFn<CreditFormData> = (key, value, data) => {
    switch (key) {
        case 'type':
            if (typeof value !== 'string' || (typeof value === 'string' && value.trim().length === 0)) {
                return 'credit-validation-type'
            }
            return
        case 'start_date':
        case 'end_date':
            if (value && data.end_date < data.start_date) {
                return 'credit-validation-date-end-switched'
            }
            return
        case 'skus':
            if (!value || (Array.isArray(value) && value.length === 0)) {
                return 'credit-validation-skus-empty'
            }
            return
        default:
            return
    }
}

function validateCreation(creditData: CreditFormData) {
    return FormUtils.validate(creditData, creationValidator)
}

function validateUpdate(creditData: CreditFormData) {
    return FormUtils.validate(creditData, creationValidator)
}

export { validateCreation, validateUpdate }
